let TP_SERVER_DOMAIN, EXPLORER_TRANSIT_DOMAIN, TRANSIT_DOMAIN, COOKIE_DOMAIN;

if (process.env.VUE_APP_ENV === 'production') {
    TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://explorer.transit.finance'
    TRANSIT_DOMAIN = 'https://swap.transit.finance'
    COOKIE_DOMAIN = 'transit.finance'
}
else if (process.env.VUE_APP_ENV === 'beta') {
    TP_SERVER_DOMAIN = 'https://betaserver.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/swap-explorer'
    TRANSIT_DOMAIN = 'https://swap.transit.finance'
    COOKIE_DOMAIN = 'transit.finance'
  }
  else if (process.env.VUE_APP_ENV === 'dev') {
    TP_SERVER_DOMAIN = 'https://testserver.mytokenpocket.vip';
    EXPLORER_TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro/swap-explorer'
    TRANSIT_DOMAIN = 'https://test-tp.tokenpocket.pro'
    COOKIE_DOMAIN = 'tokenpocket.pro'
}

export { TP_SERVER_DOMAIN, EXPLORER_TRANSIT_DOMAIN, TRANSIT_DOMAIN, COOKIE_DOMAIN }